/**
 * Identificadores de país usados pelo backend.
 *
 * Derivado de `app/constants/country.constant.js` (constante AngularJS `COUNTRY`),
 * onde cada país expõe um `ID` numérico. Mantém os mesmos valores para
 * preservar compatibilidade com o runtime híbrido durante o NgUpgrade.
 */
export enum CountryId {
  AR = 1,
  PT = 2,
  BR = 3,
  CL = 4,
  MX = 5,
  EC = 6,
  ES = 7,
}
